import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,

} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { SmartFilter } from '../../components/common/SmartFilter';
import { get } from '../../services/https';
import { debounce } from '../../utils/helper';
import Pagination from '../../components/atoms/Pagination';
import { IProduct } from '../../utils/entities/interface';
import { ProductList } from '../../components/ui/list/Products';
import { headerProductTable } from '../../utils/constants';

const Product: React.FC = () => {
  const navigate = useNavigate();

  const [products, setProducts] = useState<IProduct[]>([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState<string | undefined>('');
  const limit = rowsPerPage;

  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      const res = await get('/api/v1/admin/shop/product-list', {
        params: {
          page,
          limit,
          search: searchQuery || '',
        },
      });

      setProducts(res.data?.data || []);
      setTotalPages(res.data?.pagination?.totalPages || 1);
      // The API returns the exact count as `pagination.total` (there is no
      // `totalItems` field) — reading the wrong key meant this always fell
      // through to the `totalPages * rowsPerPage` estimate, which overstates
      // the count whenever the last page isn't completely full.
      setTotalItems(
        res.data?.pagination?.total ??
          (res.data?.pagination?.totalPages || 1) * rowsPerPage,
      );
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error('Failed to fetch products', error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [page, searchQuery, rowsPerPage]);

  const handleAdd = () => {
    navigate('/add-product');
  };

  const handleSearchRefresh = debounce((search: string) => {
    setSearchQuery(search);
    setPage(1);
  }, 500);

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100%',
      }}
    >
      {/* Header */}
      {/* <Box display="flex" justifyContent="space-between" mb={3}>
        <Typography variant="h4" fontWeight="bold">
          Product List
        </Typography>

        <Box display="flex" gap={2}>
          <TextField
            placeholder="Search product"
            size="small"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon sx={{ mr: 1 }} />,
            }}
          />

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate('/add-product')}
          >
            Add
          </Button>
        </Box>
      </Box> */}

      <SmartFilter
        title="Feature Product"
        createFilter={['SEARCH', 'ADD']}
        addHeader={'Add'}
        addbuttontitle="Add"
        onNavigate={handleAdd}
        onSearch={handleSearchRefresh}
        addDrawerSize="md"
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          p: 1,
        }}
      >
        <Box
          sx={{
            height: '100%',
            maxHeight: '100%',
            overflowY: 'scroll',
            scrollbarWidth: 'none',
          }}
        >
          {products.length <= 0 && !isLoading ? (
            <Typography textAlign={'center'} marginTop={'20%'}>
              No Products Found
            </Typography>
          ) : (
            <ProductList
              headerCells={headerProductTable}
              products={products}
              isLoading={isLoading}
              // onManageClick={handleOpenManageDrawer}
            />
          )}
        </Box>

        {/* Table */}
        {/* <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {[
                  'Product Name',
                  'Brand',
                  'AC Type',
                  'Tonnage',
                  'Model No',
                  'MRP',
                  'Customer Price',
                  'Featured',
                  'Action',
                ].map((head) => (
                  <TableCell key={head} sx={{ fontWeight: 600 }}>
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {products.map((product) => (
                <TableRow key={product._id}>
                  <TableCell>{product.name}</TableCell>
                  <TableCell>{product.brand}</TableCell>
                  <TableCell>{product?.acType || '-'}</TableCell>
                  <TableCell>{product?.tonnage || '-'}</TableCell>
                  <TableCell>{product.model || '-'}</TableCell>
                  <TableCell>£ {product?.mrp?.toLocaleString()}</TableCell>
                  <TableCell>
                    £ {product?.customerPrice?.toLocaleString()}
                  </TableCell>
                  <TableCell>{product.featured ? 'Yes' : 'No'}</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => navigate(`/productdetails/${product._id}`)}
                    >
                      <VisibilityIcon color="primary" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {products.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No products found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer> */}

        {/* Pagination */}
        <Box display={'block'} bottom={0} right={0}>
          <Pagination
            count={totalItems}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Product;
